var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import CheckboxField from "../../Form/CheckboxField";
import { DepartmentMultiSearch } from "../Department/DepartmentSearch";
import TextField from "../../Form/TextField";
import DepartmentService from "../../../Services/Department.service";
export const SSE_FORM_DEPARTMENT_INTEREST_QUESTION_GET_CRITERIA = (formState) => {
    return formState;
};
export const SSE_FORM_DEPARTMENT_INTEREST_QUESTION_GET_FORM_STATE = (formField) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const getIfArrayHasItems = (arr, service) => {
        if (arr === null || arr === void 0 ? void 0 : arr.length) {
            return service(arr);
        }
        return Promise.resolve([]);
    };
    const [departments] = yield Promise.all([
        getIfArrayHasItems((_a = formField.criteria) === null || _a === void 0 ? void 0 : _a.departmentIds, (ids) => DepartmentService.findAllById(ids)),
    ]);
    return Object.assign(Object.assign({}, formField), { criteria: Object.assign(Object.assign({}, formField.criteria), { departments }) });
});
const SSEFormDepartmentInterestQuestionForm = ({ makeName, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { maxLength: 60, name: makeName("fieldLabel"), label: "Question Label" }), _jsx(CheckboxField, { label: "Required", name: makeName("required") }), _jsx(CheckboxField, { label: "Only allow prospects to select one Department", title: "Only allow prospects to select one Department", name: makeName("criteria.limitSelectFieldToOne"), helpText: "Checking this box will allow prospects to select only one department from the form. Leaving this box unchecked will allow up to 5 departments to be selected." }), _jsx(SearchField, { label: "Department", name: makeName("criteria.departments"), as: (provided) => (_jsx(DepartmentMultiSearch, Object.assign({}, provided))), helpText: "Only selected departments on this field will be displayed on the form. By leaving this field empty, all current active departments in the system will be displayed." })] }));
};
export const SSEFormDepartmentInterestFormComponent = {
    form: SSEFormDepartmentInterestQuestionForm,
    getCriteria: SSE_FORM_DEPARTMENT_INTEREST_QUESTION_GET_CRITERIA,
    getFormState: SSE_FORM_DEPARTMENT_INTEREST_QUESTION_GET_FORM_STATE,
};
